import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators} from '@angular/forms';
import {DateAdapter, ErrorStateMatcher, MAT_DATE_LOCALE} from '@angular/material/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';

export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState (control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-regulation-dialog',
  templateUrl: './regulation-dialog.component.html',
  styleUrls: [ './regulation-dialog.component.scss' ]
})

export class RegulationDialogComponent implements OnInit, OnDestroy {

  public Editor = ClassicEditor

  public matcher = new FormErrorStateMatcher(); // 
  public entityForm: FormGroup;
  public isEdit: boolean = false;

  // Variáveis para upload
  selectedFile: File | null = null;
  selectedFileName: any | null = null;
  storedFile: any | null = null;

  public types: any = []

  constructor (
    public matDialogRef: MatDialogRef<RegulationDialogComponent>,
    private fb: FormBuilder,
    private _adapter: DateAdapter<any>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    // console.log("dialog data: " + JSON.stringify(this.data));
    this.entityForm = this.createForm(this.data)
    this.isEdit = this.data.id !== '0';

    this.types.push({id: 'Lei', name: 'Lei'});
    this.types.push({id: 'Portaria', name: 'Portaria'});
    this.types.push({id: 'Resolução', name: 'Resolução'});

  }

  ngOnInit () {
    this._adapter.setLocale('pt');
  }

  ngOnDestroy () { }

  createForm (data: any) {
    let form: FormGroup = this.fb.group({
      id: new FormControl(data.id),
      link: new FormControl(data.link),
      publish: new FormControl(data.publish),
      file: new FormControl(data.file),
      src: new FormControl(data.src),
      title: new FormControl(data.title, [ Validators.required ]),
      type: new FormControl(data.type, [ Validators.required ]),
      date: new FormControl(data.date?.toDate() || null, [ Validators.required ]),
      subject: new FormControl(data.subject),
      number: new FormControl(data.number),
    });

    this.selectedFileName = data.file;
    this.storedFile = data.src;

    return form
  }

  onFileSelected (event: any): void {
    const file: File = event.target.files[ 0 ];
    if (file) {
      this.selectedFile = file;
      this.entityForm.controls.file.setValue(file.name);
      this.selectedFileName = file.name
    }
  }

}

